import { Box, useMantineColorScheme } from "@mantine/core";
import { cloneElement } from "react";
import { useTranslation } from "react-i18next";

import { TextSerif } from "../TextSerif";

import type { FC, ReactElement } from "react";

export interface FormFieldProps {
  children: ReactElement<{ withAsterisk?: boolean; required?: boolean }>;
  required?: boolean;
}

export const FormField: FC<FormFieldProps> = ({ children, required }) => {
  const { t } = useTranslation();

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  const childWithProps = cloneElement(children, {
    required,
    withAsterisk: false,
  });

  return (
    <Box pos="relative">
      {childWithProps}
      {required && (
        <TextSerif size="sm" c={isDark ? "danger.10" : "danger.7"} pos="absolute" top={0} right={0}>
          *{t("common.required")}
        </TextSerif>
      )}
    </Box>
  );
};
